import React, { useMemo } from 'react';
import { Rule } from 'antd/lib/form';
import { useTranslation } from 'react-i18next';
import { FormInputNew } from 'components/Input/FormInputNew';

interface IProps {
	onChange: (value: string) => void;
	setId: string;
}

export const SetNameField: React.FC<IProps> = React.memo(({ onChange, setId }) => {
	const { t } = useTranslation('error');
	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterSetName') }], [t]);

	return (
		<FormInputNew
			testId="SetName"
			name={`name-${setId}`}
			label="setNameLabel"
			onChange={onChange}
			validationRules={validationRules}
		/>
	);
});
